<template>
  <!-- 移动端登录 -->
  <div class="m-login-wrap">
    <div class="login-form">
      <p class="login-title">登录</p>
      <div class="login-content">
        <div class="login-tab">
          <div class="login-tab-item login-tab-stu">学生</div>
          <div class="login-tab-item login-tab-tea" @click="goTeaLogin">教师</div>
        </div>
        <el-form :model="userForm" :rules="userRule" ref="userForm">
          <div class="form-title">用户名</div>
          <el-form-item prop="userName">
            <el-input name="userName" v-model="userForm.userName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <div class="form-title">密码</div>
          <el-form-item prop="password">
            <el-input name="password" type="password" v-model="userForm.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <div v-if="verifyCode">
            <div class="form-title">验证码</div>
            <el-form-item prop="verify">
              <div class="verify-code-item">
                <el-input name="verifyCode" v-model="userForm.verify" placeholder="请输入验证码"></el-input>
                <div class="verify-code">{{verifyCode}}</div>
              </div>
              <p v-if="showVerifyCode" class="verify-code-tips">请输入验证码</p>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button @click="goLogin('userForm')">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="other-btns">
          <!-- <a @click="goRegister">注册账号</a>
          <span>｜</span> -->
          <a href="http://web.etiantian.com/ett20/study/common/index1.jsp" target="_blank">忘记密码</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userForm: {
        userName: '',
        password: '',
        verify: ''
      },
      userRule: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      verifyCode: '', // 验证码
      showVerifyCode: false,
      webhost: '//web.etiantian.com'
      // webhost: 'https://gw1-bj.etiantian.net:15280'
    }
  },
  created() {
    this.getWebUrl()
  },
  methods: {
    goLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {
            userName: this.userForm.userName,
            password: this.userForm.password,
            userType: 3 // 学生登录 userType为3
          }
          if (this.verifyCode) {
            if (!this.userForm.verify) {
              this.showVerifyCode = true
              return
            } else {
              this.showVerifyCode = false
              param.verifyCode = this.userForm.verify
            }
          }
          let loginUrl = `${this.$etturl}home/checkUserName.do?callback=?`
          $.ajax({
            type: 'post',
            url: loginUrl,
            cache: false,
            async: false,
            dataType: 'jsonp',
            jsonp: "jsoncallback",
            data: param,
            success: (res) => {
              if (res.result != 1) {
                this.$toast.center('用户名或密码错误')
                this.verifyCode = res.data.verifyCode
                this.userForm.verify = ''
              } else {
                let url = this.webhost + "/ett20/study/common/login.jsp"
                document.forms[0].setAttribute('action', url)
                document.forms[0].setAttribute('method', 'post')
                document.forms[0].setAttribute('target', '_self')
                document.forms[0].setAttribute('accept-charset', 'gbk')
                document.forms[0].submit()
              }
            }
          })
        }
      })
    },
    goRegister() {
      let url = this.$router.resolve({
        path: '/register'
      })
      window.open(url.href, '_blank')
    },
    goTeaLogin() {
      window.open('https://school-web.ai-classes.com/elogin/#/', '_blank')
    },
    getWebUrl() {
      //web地址
      let webhost = '//web.etiantian.com'
      let currhost = window.location.host
      if (currhost.match(/(www\.etiantian\.net)$/g)) {
          webhost = '//web.etiantian.net'
      } else if (currhost.match(/(\.crtc\.etiantian\.com)$/g)) {
          webhost = '//web.crtc.etiantian.com'
      } else if (currhost.match(/(www2\.etiantian\.net)$/g)) {
          webhost = '//web2.etiantian.net'
      } else if (currhost.match(/(\.etiantian\.net)$/g)) {
          webhost = '//web.etiantian.net'
      } else if (currhost.match(/(\.etiantian\.com)$/g)) {
          webhost = '//web.etiantian.com'
      }
      this.webhost = webhost
    }
  }
}
</script>
<style lang="scss" scoped>
.m-login-wrap {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding: 1.5rem .72rem 0;
  font: .28rem/1.5 "Microsoft Yahei", tahoma, Srial, helvetica, sans-serif;
  .login-form {
    width: 100%;
    .login-title {
      display: inline-block;
      font-size: .6rem;
      line-height: .6rem;
      font-weight: bold;
      color:rgba(33,124,254,1);
      border-bottom: .14rem solid rgba(255,129,86,1);
      text-align: center;
    }
    .login-content {
      margin-top: .76rem;
      .login-tab {
        display: flex;
        width: 100%;
        font-size: .3rem;
        border-bottom: 0.01rem solid #ccc;
        &-item {
          width: 50%;
          height: .76rem;
          text-align: center;
          cursor: pointer;
          font-weight: 500;
          margin: 0 .4rem;
        }
        &-stu {
          color: #217CFE;
          border-bottom: .01rem solid #217CFE;
        }
        &-tea {
          color: #333;
          border-bottom: .01rem solid transparent;
        }
      }
      .form-title {
        font-size: .28rem;
        color: #222;
        padding: .52rem 0 .15rem;
      }
      .verify-code-item {
        display: flex;
      }
      .verify-code {
        flex-shrink: 0;
        width: 1.88rem;
        height: .76rem;
        line-height: .76rem;
        text-align: center;
        font-size: .36rem;
        border: .01rem solid rgba(213, 213, 213, 1);
        border-radius: .1rem;
        letter-spacing: .03rem;
        font-weight: bolder;
        font-family: Arial;
        margin-left: .12rem;
      }
      .verify-code-tips {
        color: #F56C6C;
        font-size: .24rem;
        line-height: 1;
        padding-top: .08rem;
        position: absolute;
        top: 100%;
        left: 0;
      }
      .other-btns {
        text-align: center;
        font-size: .28rem;
        color: #4f4f4f;
        line-height: .33rem;
        margin-top: .56rem;
        a {
          color: #7E7E7E;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.m-login-wrap {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__content {
    line-height: .76rem;
    .el-input {

    }
    .el-input__inner {
      width: 100%;
      height: .76rem;
      line-height: .76rem;
      border: none;
      border-bottom: 1px solid #e5e5e5;
      font-weight: bold;
      padding: 0;
      color: #4F4F4F;
    }
  }
  .verify-code-item {
    .el-input__inner {
      border-radius: .1rem 0 0 .1rem;
    }
  }
  .el-button {
    display: block;
    width: 6rem;
    height: .88rem;
    line-height: .88rem;
    background: #ff8156;
    box-shadow: 0px 11px 21px 0px rgba(255, 86, 129, 0.35);
    border-radius: .44rem;
    font-size: .36rem;
    color: rgba(255,255,255,1);
    text-align: center;
    padding: 0;
    margin: 0 auto;
    margin-top: .72rem;
  }
  .el-button:active {
    border-color: #ff8156;
  }
}
</style>